"use client";

import styled from "styled-components";

export const Box = styled.div<{ $height?: string }>`
  display: flex;
  padding: var(--Spacing-24, 2.4rem) var(--Spacing-16, 1.6rem);
  height: ${({ $height }) => $height};
  flex-direction: column;
  align-items: center;
  border-radius: var(--Border-Radius-8, 0.8rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  background: var(--Color-Common-Bg-Primary, #fff);
  width: 100%;
`;
